var hotjar = require('./src/react-hotjar');

module.exports = {
	hotjar: {
		initialize: function initialize(id, sv) {
			hotjar(id, sv);
		}
	}
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/react-hotjar/index.js
// module id = 970
// module chunks = 0